export default {
  DOOR_OPENER: "/:webToken"
};
